module.exports = __webpack_public_path__ + "img/nf.d5a6b8e5.svg";